export default {
    title: '面试签到',
    abnormal_404: '你要访问的页面不见了……',
    abnormal_404_sub: '请检查网址是否正确',
    confirm: '确定',
    cancel: '取消',
    VerifyWithIdentity: '身份验证',
    enterPhone: '请输入手机号码',

    // m-select-tree
    'mselect.placeholderIndex': '请选择',
    'mselect.countryAndCityTreePlaceholder': '搜索国家或地区',
    'mselect.TreeSelectCancel': '取消',
    'mselect.countryAndCityTreeTitle': '选择国家或地区',
    'mselect.notFound': '未找到',

    // login
    phoneErrorMsg: '手机号码不正确，请重新输入',
    verificationCode: '验证码',
    validCodeFormatError: '验证码错误，请重试',
    resendValidCode: '重新获取({second}s)',
    fetchValidCode: '获取验证码',
    verifyFrequent: '请求过于频繁，请 1 分钟后再试',
    validCodeSent: '验证码已发送',
    login: '下一步',
    loginTitle: '身份验证',
    back: '返回',

    // back页面
    noInterviewToday: '今日无面试，你最近的面试信息如下',
    noInterview: '无面试信息',
    job: '面试职位：',
    jobWithoutColon: '面试职位',
    interviewTime: '面试时间：',
    interviewTimeWithoutColon: '面试时间',
    location: '面试地点：',
    locationWithoutColon: '面试地点',

    // interviewList页面
    interviewListTitle: '{name}，你好！请确认你本次要参加的面试',
    checkIn: '签到',

    // 签到成功页面
    checkInSucc: '签到成功',
    notifiedHRP1: '已通知 HR 及面试官，请稍候',
    HR: 'HR：',
    tel: '联系电话：',
    notifiedHRP2: '如需帮助',
    notifiedHRP3: '联系HR',
    fillRegistration: '填写面试登记表',
    editRegistration: '更新面试登记表',
    fillRegistrationNotification: '等待时请完善面试登记表',
    editRegistrationNotification: '你已填写过面试登记表，若信息有变，请进行 <a href={url}>更新</a>',
    // 请求失败抛出错误
    MessageNetworkError: '网络出现问题，请稍后重试',
    MessageHttpError: '系统出现问题，请稍后重试',
    MessageNetworkDisconnected: '网络断开，请检查网络连接',

    // 现场申请面试
    walkInInterview: '无预约面试',
    applyInterviewTitle: '如你已在面试现场，可申请面试',
    applyInterviewCTA: '我已在面试现场，申请面试',
    scanWaiting: '请将此二维码出示给你的面试官',
    notAvailableAddress: '该职位地点无法用于面试',
    applyInterviewHeader: '请确认要面试的职位',
    applyInterviewHeaderSingle: '你当前有 1 个职位可申请面试，请确认',
    applicationTime: '投递时间：',
    applicationTimeWithoutColon: '投递时间',
    requestNewInterview: '申请新面试',
    noApplicationsCannotRequest: '无可面试职位，请重新投递或联系招聘方',
    pleaseSelectLocation: '选择参加面试的地点',
    searchLocation: '搜索地点',
    noInterviewLocation: '无面试地点',
    comma: '、',
    cannotArrangeInterview: '由招聘方流转至“面试”阶段后，可申请',
    loading: '加载中',
    refreshQRCode: '刷新二维码'
};
